// import hooks
import { useDocument } from "../../hooks/useDocument";
// import { useAuthContext } from "../../hooks/useAuthContext"; // Non utilizzato per ora

// import pacchetti
import { useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

// import styles
import "./Project.css";

// import componenti
import ProjectSummary from "./ProjectSummary";

export default function Project() {
  const { id } = useParams();
  const location = useLocation();
  const [isNewlyCreated, setIsNewlyCreated] = useState(false);
  const { document, error } = useDocument("projects", id);
  // const { user } = useAuthContext(); // Non utilizzato per ora

  // Controlla se il cantiere è stato appena creato (passato dallo state della location)
  useEffect(() => {
    if (location.state && location.state.isNewlyCreated) {
      setIsNewlyCreated(true);
    }
  }, [location]);

  if (error) {
    return <div className="error">{error}</div>;
  }
  if (!document) {
    return (
      <div className="loading">
        {isNewlyCreated ? "Il cantiere è stato creato. Caricamento in corso..." : "Caricamento in corso"}
      </div>
    );
  }

  return (
    <div className="project-details">
      <ProjectSummary prj={document} />
    </div>
  );
}
